/*
 * Single source of truth for the header cart badges.
 *
 * This theme renders two header badges (desktop + mobile), both always in
 * the DOM and toggled by CSS media queries, plus eight separate add/change
 * code paths across the homepage, collection, search, product, and cart
 * blocks. Previously most of those paths updated no badge at all, and the
 * one that did guessed the new count client-side instead of using the
 * server's real total.
 *
 * Every add/change handler now dispatches a single 'cart:count-changed'
 * event with the authoritative count from Shopify's response; this script
 * is the only place that touches badge DOM.
 */
(function () {
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count <= 0;
    });
  }

  window.updateCartCount = updateCartCount;

  window.addEventListener('cart:count-changed', function (e) {
    updateCartCount(e.detail.count);
  });
})();
